export default __webpack_public_path__ + "static/media/bulb.89f25e8c.svg";